// extracted by css-extract-rspack-plugin
export default {"cls1":"DebugPage-cls1_yzW","cls2":"DebugPage-cls2_yac DebugPage-cls1_yzW"};